import firebase from 'firebase';

var config = {
  apiKey: "AIzaSyA7eYLcvKvCDn9Xtx3riVDh6Zl7iiaX34Y",
  authDomain: "physicsdemo-2579c.firebaseapp.com",
  databaseURL: "https://physicsdemo-2579c.firebaseio.com",
  projectId: "physicsdemo-2579c",
  storageBucket: "physicsdemo-2579c.appspot.com",
  messagingSenderId: "1078619300919"
};

firebase.initializeApp(config);
var fire = firebase.database();
// var fire = firebase.initializeApp(config);

// var databaseRef = firebase.database().ref('demos/');
// databaseRef.on('value', function(snapshot) {
//   console.log(snapshot.val());
// });

export default fire;



// WEBPACK FOOTER //
// ./src/fire.js